import { NavLink, useLocation } from "react-router-dom";
import NavbarOther from "../../components/NavbarOther/NavbarOther";
import "./StoneSheetsDetail.css";
import productjson from "../../products.json";
import ProductCarousel from "../../components/ProductCarousel/ProductCarousel";
import Footer from "../../components/Footer/Footer";
import { Helmet } from 'react-helmet';

const StoneSheetsDetail = () => {
  const location = useLocation();
  let splittedPath = location.pathname.split("/");
  let productname = decodeURI(splittedPath[splittedPath.length - 1]);
  let product_data = productjson.filter((item) => {
    return item.url_name === productname;
  });
  return (
    <>
    <Helmet>
      <title>Flexible Stone Veneer | Stone Veneer Sheets 2MM | Stone Veneer Categories </title>
      <meta name="keywords" content="indian autumn stone veneer, autumn rustic stone veneer, k black stone veneer, ocean black stone veneer, burning forest stone veneer, silver grey stone veneer, arctic white stone veneer, silvia white stone veneer, cosmos white stone veneer, monsoon black stone veneer, rainbow stone veneer, teakwood stone veneer, mint stone veneer, indian autumn translucent stone veneer, autumn rustic translucent stone veneer" />
      <meta property="og:type" content="product" />      
    </Helmet>
      <NavbarOther></NavbarOther>
      <div className="product-detail-section">
        <h1 className="product-name-heading">{product_data[0].name}</h1>
        <div className="top-product-section">
          <div className="product-carousel-container">
            <ProductCarousel
              imageList={product_data[0].product_images}
            ></ProductCarousel>
            <div className="send-mail">
              <div className="send-mail-button-container">
                <NavLink to="/contact" className="send-mail-button">
                  Send Query
                </NavLink>
              </div>
            </div>
          </div>
          <div className="product-basic-container">
            <p>{product_data[0].about}</p>
            <p>{product_data[0].description}</p>
            <ul className="features-section">
              {Object.entries(product_data[0].details).map(([key, value]) => (
                <li className="each-feature" key={key}>
                  <span className="detail-key">{key}:</span>
                  <span className="detail-value">
                    {Array.isArray(value) ? (
                      <ul>
                        {value.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    ) : (
                      value
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default StoneSheetsDetail;
